import { pipe } from '@wiko/functional';
import {
    RpcSubscriptionsChannel,
    transformChannelInboundMessages,
    transformChannelOutboundMessages,
} from '@wiko/rpc-subscriptions-spec';

export function getRpcSubscriptionsChannelWithJSONSerialization(
    channel: RpcSubscriptionsChannel<string, string>,
): RpcSubscriptionsChannel<unknown, unknown> {
    return pipe(
        channel,
        c => transformChannelInboundMessages(c, JSON.parse),
        c => transformChannelOutboundMessages(c, JSON.stringify),
    );
}
